import { render, staticRenderFns } from "./DepartmentComponent.vue?vue&type=template&id=2b7aec52&scoped=true&"
import script from "./DepartmentComponent.vue?vue&type=script&lang=ts&"
export * from "./DepartmentComponent.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentComponent.vue?vue&type=style&index=0&id=2b7aec52&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7aec52",
  null
  
)

export default component.exports